/* eslint-disable @typescript-eslint/no-deprecated */
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react'
import zeresLogo from '../assets/zeres-logo-full.png'

const Footer = () => {
  return (
    <footer className='bg-card border-t'>
      <div className='mx-auto max-w-4xl px-4 py-10 sm:px-6'>
        <div className='text-muted-foreground grid grid-cols-1 gap-8 text-sm sm:grid-cols-3'>
          {/* Column 1: Logo + Address */}
          <div className='space-y-3'>
            <img src={zeresLogo} alt='Zeres' className='mb-2 h-8 w-auto' />
            <div>
              <p className='text-foreground font-semibold'>Zeres b.v.</p>
              <p>Zeeburgerdijk 490</p>
              <p>1095 AL AMSTERDAM</p>
            </div>
          </div>

          {/* Column 2: Contact */}
          <div className='space-y-2'>
            <p className='text-foreground mb-1 font-semibold'>Contact</p>
            <p>
              <a
                href='mailto:helpdesk@zeres.nl'
                className='hover:text-primary transition-colors'
              >
                helpdesk@zeres.nl
              </a>
            </p>
            <p>
              <a
                href='https://www.zeres.nl'
                target='_blank'
                rel='noopener noreferrer'
                className='hover:text-primary transition-colors'
              >
                www.zeres.nl
              </a>
            </p>
            <p>
              Helpdesk:{' '}
              <a
                href='tel:0850600641'
                className='hover:text-primary transition-colors'
              >
                085 - 060 0641
              </a>
            </p>
          </div>

          {/* Column 3: Social + Legal */}
          <div className='space-y-3'>
            <p className='text-foreground mb-2 font-semibold'>Volg ons</p>
            <div className='flex gap-3'>
              <a
                href='https://www.linkedin.com/company/zeres_nl'
                target='_blank'
                rel='noopener noreferrer'
                className='text-muted-foreground hover:text-primary transition-colors'
              >
                <Linkedin className='h-5 w-5' />
              </a>
              <a
                href='https://www.instagram.com/zeresbv/'
                target='_blank'
                rel='noopener noreferrer'
                className='text-muted-foreground hover:text-primary transition-colors'
              >
                <Instagram className='h-5 w-5' />
              </a>
              <a
                href='https://www.facebook.com/people/Zeres-BV/61587314947060/'
                target='_blank'
                rel='noopener noreferrer'
                className='text-muted-foreground hover:text-primary transition-colors'
              >
                <Facebook className='h-5 w-5' />
              </a>
              <a
                href='https://www.youtube.com/channel/UCK48NK4XhJeLaf3U8EEAZUg'
                target='_blank'
                rel='noopener noreferrer'
                className='text-muted-foreground hover:text-primary transition-colors'
              >
                <Youtube className='h-5 w-5' />
              </a>
            </div>
            <div className='space-y-1 pt-2 text-xs'>
              <p>KvK: 99395142</p>
              <p>BTW: NL868970591B01</p>
            </div>
          </div>
        </div>

        <div className='text-muted-foreground mt-8 border-t pt-4 text-center text-xs'>
          © {new Date().getFullYear()} Zeres b.v. Alle rechten voorbehouden.
        </div>
      </div>
    </footer>
  )
}

export default Footer
